import { render, staticRenderFns } from "./PublicSubscriptionPayment.vue?vue&type=template&id=55253c12&scoped=true"
import script from "./PublicSubscriptionPayment.vue?vue&type=script&lang=js"
export * from "./PublicSubscriptionPayment.vue?vue&type=script&lang=js"
import style0 from "./PublicSubscriptionPayment.vue?vue&type=style&index=0&id=55253c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55253c12",
  null
  
)

export default component.exports